// extracted by mini-css-extract-plugin
export var portfolio = "styles-module--portfolio--e10cd";
export var scrollContainer = "styles-module--scrollContainer--03b0a";